import React from 'react';
import { Card, Table, Tag, Row, Col, Statistic } from 'antd';
import { useNavigate } from 'react-router-dom';
import type { ControlTowerQueryParams } from '@/services/manufacturingControlTower.service';
import { useControlTowerRouteSheets } from '@/hooks/useManufacturingControlTower';

const RouteSheetControl: React.FC<{ filters?: ControlTowerQueryParams }> = ({ filters }) => {
  const navigate = useNavigate();
  const { data, isLoading } = useControlTowerRouteSheets(filters);
  const d = data as {
    register?: Record<string, unknown>[];
    missing?: Record<string, unknown>[];
    generated_count?: number;
    missing_count?: number;
  };

  return (
    <Card
      id="route-sheets"
      title="Route sheet control"
      extra={<a onClick={() => navigate('/mfg/route-sheet-register')}>Register</a>}
      style={{ marginTop: 16 }}
    >
      <Row gutter={16} style={{ marginBottom: 12 }}>
        <Col><Statistic title="Generated" value={d?.generated_count ?? 0} /></Col>
        <Col><Statistic title="Missing" value={d?.missing_count ?? 0} valueStyle={{ color: '#cf1322' }} /></Col>
      </Row>
      <Table
        size="small"
        loading={isLoading}
        title={() => 'Missing route sheets'}
        rowKey="work_order_id"
        dataSource={d?.missing ?? []}
        onRow={(r) => ({
          onClick: () => navigate(`/mfg/work-orders/${r.work_order_id}/route-sheet`),
          style: { cursor: 'pointer' },
        })}
        columns={[
          { title: 'WO', dataIndex: 'work_order_number' },
          { title: 'Scope', dataIndex: 'execution_scope' },
          { title: '', render: () => <Tag color="orange">Missing</Tag> },
        ]}
        pagination={{ pageSize: 10 }}
      />
    </Card>
  );
};

export default RouteSheetControl;
